import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from "prop-types";

const BlurryBackdrop = (props) => {

    return (

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, backdropFilter: "blur(5px)" }}
            open={props.open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

BlurryBackdrop.propTypes = {
    open: PropTypes.bool
};

export default BlurryBackdrop;